import React, {useRef, useState, useEffect, useMemo } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../store/auth";
import Sidebar from "./Sidebar";
import PageHeader from "./PageHeader";
export const HeaderHeightContext = React.createContext(() => {});

const Layout = React.memo(() => {
  const { user, logout } = useAuth();
  const location = useLocation();

  const [mobileOpen, setMobileOpen] = useState(false);
  const [usersOpen, setUsersOpen] = useState(
    localStorage.getItem("usersOpen") === "true"
  );
   const [accessOpen, setAccessOpen] = useState(
    localStorage.getItem("accessOpen") === "true"
  );
  const [competitionOpen, setCompetitionOpen] = useState(
    localStorage.getItem("competitionOpen") === "true"
  );
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);
 const headerRef = useRef(null);
  const [headerHeight, setHeaderHeight] = useState(0);

  // 🔥 funkcja do przeliczenia wysokości headera
  const updateHeaderHeight = () => {
  const headerEl = document.getElementById("global-page-header");
  if (!headerEl) return;

  const currentIsMobile = window.innerWidth < 1024; // zawsze aktualne!

  const height = headerEl.offsetHeight + (currentIsMobile ? 50 : 0);

  setHeaderHeight(height);
};

  // 🔥 ResizeObserver śledzący zmianę wysokości PageHeader
  useEffect(() => {
    const headerEl = document.getElementById("global-page-header");
    if (!headerEl) return;

    const observer = new ResizeObserver(() => updateHeaderHeight());
    observer.observe(headerEl);

    updateHeaderHeight(); // pierwsze odczytanie

    return () => observer.disconnect();
  }, []);

  // 🔥 Reakcja na resize okna
  useEffect(() => {
    const handleResize = () => {
      clearTimeout(window.__resizeTimer);
      window.__resizeTimer = setTimeout(() => {
        setIsMobile(window.innerWidth < 1024);
        updateHeaderHeight(); // <-- WAŻNE: przeliczamy header ponownie przy resize!
      }, 100);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleDrawerToggle = () => setMobileOpen(!mobileOpen);
  const handleUsersClick = () => {
    setUsersOpen((prev) => {
      const newVal = !prev;
      localStorage.setItem("usersOpen", newVal);
      return newVal;
    });
  };
  const handleAccessClick = () => {
    setAccessOpen((prev) => {
      const newVal = !prev;
      localStorage.setItem("accessOpen", newVal);
      return newVal;
    });
  };
  const handleCompetitionClick = () => {
    setCompetitionOpen((prev) => {
      const newVal = !prev;
      localStorage.setItem("competitionOpen", newVal);
      return newVal;
    });
  };
  const isActive = useMemo(
    () => (path) => location.pathname === path,
    [location.pathname]
  );

  return (
    <div className="flex min-h-screen bg-slate-50">
      {/* 📱 Mobile top bar */}
      {isMobile && (
        <div className="fixed top-0 left-0 right-0 z-40 bg-gradient-to-r from-primary-500 via-primary-600 to-primary-700 shadow-xs">
          <div className="flex items-center justify-between px-4 py-3">
            <button
              onClick={handleDrawerToggle}
              className="text-white p-2 hover:bg-white/10 rounded-lg transition-colors"
            >
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M4 6h16M4 12h16M4 18h16"
                />
              </svg>
            </button>
            <h1 className="text-white font-bold text-lg">HShop 2</h1>
            <div className="w-10" />
          </div>
        </div>
      )}

      {/* 🧭 Desktop Sidebar */}
      {!isMobile && (
        <aside className="fixed left-0 top-0 h-screen w-64 bg-gray-900 text-white shadow-xs overflow-y-auto scrollbar-thin scrollbar-thumb-gray-700 scrollbar-track-gray-900 z-40">
          <Sidebar
            user={user}
            logout={logout}
            isMobile={false}
            closeMobile={() => {}}
            usersOpen={usersOpen}
            handleUsersClick={handleUsersClick}
            isActive={isActive}
               accessOpen={accessOpen}
              handleAccessClick={handleAccessClick}
              competitionOpen={competitionOpen}
              handleCompetitionClick={handleCompetitionClick}
          />
        </aside>
      )}

      {/* 📱 Mobile Sidebar */}
      {isMobile && (
        <>
          <aside
            className={`fixed top-0 left-0 z-50 h-screen w-64 bg-gray-900 text-white transition-transform duration-300 ease-in-out ${
              mobileOpen ? "translate-x-0" : "-translate-x-full"
            } overflow-y-auto`}
          >
            <Sidebar
              user={user}
              logout={logout}
              isMobile
              closeMobile={() => setMobileOpen(false)}
              usersOpen={usersOpen}
              handleUsersClick={handleUsersClick}
              accessOpen={accessOpen}
              handleAccessClick={handleAccessClick}
              isActive={isActive}
                competitionOpen={competitionOpen}
              handleCompetitionClick={handleCompetitionClick}
            />
          </aside>

          {mobileOpen && (
            <div
              className="fixed inset-0 bg-black/40 z-40 backdrop-blur-sm"
              onClick={handleDrawerToggle}
            ></div>
          )}
        </>
      )}

      {/* 🧱 Main content */}
                  <div id="global-page-header" className="lg:ml-64 fixed   top-[64px] lg:top-0 left-0 right-0 z-30"></div>

      <main
        className={`flex-1 flex flex-col transition-all duration-300 ${
          isMobile ? "" : "ml-64"
        }`}
         style={{ marginTop: headerHeight }}
      >
        <div className="flex-1 p-2 sm:p-4 bg-gradient-to-br from-slate-50 via-indigo-50/20 to-blue-50/30 relative">
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_20%,rgba(99,102,241,0.05),transparent_50%),radial-gradient(circle_at_70%_80%,rgba(59,130,246,0.05),transparent_50%)] pointer-events-none"></div>
          <div className=" z-30 w-full mx-auto mt-">

            <Outlet />
          </div>
        </div>

        {/* ⚙️ Footer */}
        <footer className="py-2 px-6 bg-gradient-to-r from-slate-50 via-white to-slate-50 border-t border-slate-200/80">
          <p className="text-slate-600 text-center text-xs">
            © 2026 HShop 2 • Profesjonalne zarządzanie licencjami
          </p>
        </footer>
      </main>
    </div>
  );
});

export default Layout;
